<template>
  <van-nav-bar
    :title="title"
    left-text="返回"
    left-arrow
    @click-left="onClickLeft"
    safe-area-inset-to
  />
</template>
<script>
export default {
  props:{
    title:{
      typeof:String,
      default:"",
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>
